import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import ExamForm from '../../components/admin/ExamForm';
import Alert from '../../components/common/Alert';
import { createExam } from '../../api/admin.api';

const toUTC = (localStr) => (localStr ? new Date(localStr).toISOString() : '');

const DEFAULTS = {
  title: '', description: '', duration_minutes: 60, pass_marks: 0,
  max_tab_switches: 3, allow_result_view: false, instructions: '',
  scheduled_start: '', scheduled_end: '',
  access_code: Math.random().toString(36).substring(2, 8).toUpperCase(),
  negative_marks_per_wrong: 0,
};

const ExamCreate = () => {
  const [form, setForm] = useState(DEFAULTS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await createExam({
        ...form,
        scheduled_start: toUTC(form.scheduled_start),
        scheduled_end: toUTC(form.scheduled_end),
      });
      navigate(`/admin/exams/${res.data.data.id}`);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create exam');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-2xl">
        <div className="mb-7">
          <h1 className="text-2xl font-bold text-slate-900">Create New Exam</h1>
          <p className="text-slate-500 text-sm mt-0.5">Fill in the details below to create a new assessment.</p>
        </div>
        {error && <Alert type="error" className="mb-5">{error}</Alert>}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-card p-7">
          <ExamForm form={form} setForm={setForm} onSubmit={handleSubmit} loading={loading} submitLabel="Create Exam" />
        </div>
      </div>
    </AdminLayout>
  );
};

export default ExamCreate;
